module.exports = __webpack_public_path__ + "static/media/hotel_de_ville_thumb.80a9635a.jpg";